// ハンバーガーボタンの各種 aria 属性値を設定
var buttonAttr = {
  controls: 'drawer',
  expanded: 'false',
  label: 'メインメニュー'
}; // ハンバーガーボタンの HTML を準備

var buttonStr = '<button' + ' id' + '="' + 'hamburger' + '"' + ' class' + '="' + 'hamburger-button' + '"' + ' type' + '="' + 'button' + '"' + ' aria-controls' + '="' + buttonAttr.controls + '"' + ' aria-expanded' + '="' + buttonAttr.expanded + '"' + ' aria-label' + '="' + buttonAttr.label + '"' + '>' + '<span class="bar"></span>' + '<span class="bar"></span>' + '</button>'; // 対象要素を取得

var $hamburger = $(buttonStr);
var $drawer = $('#drawer'); // const $overlay   = $('#drawerOverlay');
// 状態定義

var isDrawerShow = false; // ドロワーの表示状態を保存

var isTouch = false; // タッチイベントの制御フラグ
// 表示切り替えの状態を付与する要素を設定

var switchTarget = '#root';
/**
 * 関数定義
 */
// 表示切り替え

var switchDrawer = function switchDrawer() {
  // ドロワーの表示状態を切り替え
  isDrawerShow = isDrawerShow ? false : true; // ドロワーの表示状態に合わせて aria 属性値を変更

  $(switchTarget).attr('data-drawer-active', isDrawerShow);
  $hamburger.attr('aria-expanded', isDrawerShow);
  $drawer.attr('aria-hidden', !isDrawerShow); // $overlay.attr('aria-hidden', !isDrawerShow);
}; // ハンバーガーボタン設置


var setButton = function setButton() {
  $('.l-page').prepend($hamburger);
}; // ハンバーガーボタンのクリック（タップ）時のイベントハンドラ


var touchHandler = function touchHandler(event) {
  // touchstart と click が重複して挙動がおかしくなるのを回避
  switch (event.type) {
    case 'touchstart':
      switchDrawer(); // touch = true;

      isTouch = true;
      return false;
      break;

    case 'click':
      if (!isTouch) {
        switchDrawer();
      }

      return false;
      break;
  }
};
/**
 * イベント設定
 */


$hamburger.on('click touchstart', touchHandler);
$('#drawerClose').on('click touchstart', touchHandler);
/**
 * 初期化処理
 */

$(switchTarget).attr('data-drawer-active', 'false');
$drawer.attr('aria-hidden', 'true'); // $overlay.attr('aria-hidden', 'true');

setButton(); // JS 有効時のみハンバーガーボタンを生成